import { Button, Card, Col, Form, Input, Row, Space, Typography } from "antd";
import {
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React from "react";
import "./user-form.scss";

interface UserFormProps {
  onSubmit: (values: any, add?: boolean) => void;
  user?: any;
}

const { Item } = Form;
const { Title, Text } = Typography;

const UserForm: React.FC<UserFormProps> = ({ onSubmit, user }) => {
  const handleSubmit = (values: any) => {
    let formValue: any = null;

    if (!user) {
      formValue = {
        ...values,
      };
    } else {
      formValue = {
        ...user,
        ...values,
      };
    }

    onSubmit(formValue, !user);
  };

  return (
    <div className="user-form-page">
      <Card className="user-form-card" bordered={false}>
        <div className="user-form-header">
          <div>
            <Title level={2} className="user-form-title">
              {user ? "Edit User" : "Create New User"}
            </Title>
            <Text className="user-form-subtitle">
              {user
                ? "Kullanıcı bilgilerini düzenle."
                : "Yeni kullanıcıyı temiz ve düzenli şekilde oluştur."}
            </Text>
          </div>
        </div>

        <Form
          layout="vertical"
          onFinish={(values) => handleSubmit(values as any)}
          initialValues={user || undefined}
          className="premium-user-form"
        >
          <div className="user-form-section">
            <div className="user-form-section-title">Basic Information</div>

            <Row gutter={[16, 0]}>
              <Col xs={24} md={12}>
                <Item
                  label="Full Name"
                  name="name"
                  rules={[{ required: true, message: "Name is required" }]}
                >
                  <Input
                    size="large"
                    prefix={<UserOutlined />}
                    placeholder="Enter full name"
                  />
                </Item>
              </Col>

              <Col xs={24} md={12}>
                <Item
                  label="Email"
                  name="email"
                  rules={[
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input
                    size="large"
                    prefix={<MailOutlined />}
                    placeholder="Enter email address"
                  />
                </Item>
              </Col>
            </Row>

            <Row gutter={[16, 0]}>
              <Col xs={24} md={12}>
                <Item
                  label="First Name"
                  name="firstname"
                  rules={[
                    { required: true, message: "First Name is required" },
                  ]}
                >
                  <Input
                    size="large"
                    prefix={<UserOutlined />}
                    placeholder="Enter first name"
                  />
                </Item>
              </Col>

              <Col xs={24} md={12}>
                <Item
                  label="Last Name"
                  name="lastname"
                  rules={[{ required: true, message: "Last Name is required" }]}
                >
                  <Input
                    size="large"
                    prefix={<UserOutlined />}
                    placeholder="Enter last name"
                  />
                </Item>
              </Col>
            </Row>

            <Row gutter={[16, 0]}>
              <Col xs={24} md={12}>
                <Item label="Phone" name="phone">
                  <Input
                    size="large"
                    prefix={<PhoneOutlined />}
                    placeholder="Enter phone number"
                  />
                </Item>
              </Col>

              {!user && (
                <Col xs={24} md={12}>
                  <Item
                    label="Password"
                    name="password"
                    rules={[
                      { required: true, message: "Password is required" },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      prefix={<LockOutlined />}
                      placeholder="Create password"
                    />
                  </Item>
                </Col>
              )}
            </Row>
          </div>

          <div className="user-form-footer">
            <Space size={12}>
              <Button size="large" htmlType="button">
                Cancel
              </Button>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="user-form-submit-btn"
              >
                {user ? "Save Changes" : "Create User"}
              </Button>
            </Space>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default UserForm;
